import React, { useState, useEffect } from "react";
import moment from "moment";

const CustomDateTimePicker = (props) => {
  // const [id, setId] = useState(null);

  let id = window.$(`#${props.id}`);

  useEffect(() => {
    if (id) {
      id.datetimepicker();
    }
  }, [id]);

  useEffect(() => {
    if (id != null) {
      id.on("dp.change", function(e) {
        props.setDateValue(e.target.value);
      });
    }
  }, [id]);

  return (
    <>
      <div
        className="input-group date"
        id="kt_datetimepicker_1"
        data-target-input="nearest"
      >
        <input
          type="text"
          className="form-control datetimepicker-input"
          placeholder="Select date & time"
          data-target={props?.id}
          id={props.id}
          value={
            props?.dateValue
              ? moment.utc(props?.dateValue).format("MM/DD/YYYY  hh:mm:ss A")
              : ""
          }
        />
        <div
          className="input-group-append"
          data-target={props?.id}
          data-toggle="datetimepicker"
        >
          <span className="input-group-text">
            <i className="ki ki-calendar" />
          </span>
        </div>
      </div>
    </>
  );
};

export default CustomDateTimePicker;
